import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { V2User } from "@/v2/shared/model";
import { V2_USERS, findV2UserById } from "@/v2/auth/users";

const DEFAULT_USER = V2_USERS.find((u) => u.role === "manager") ?? V2_USERS[0];

const currentUserIdAtom = atomWithStorage<string>(
  "pza.v2.currentUserId",
  DEFAULT_USER.id,
  undefined,
  { getOnInit: true },
);

export const v2CurrentUserAtom = atom(
  (get): V2User => findV2UserById(get(currentUserIdAtom)) ?? DEFAULT_USER,
  (_get, set, user: V2User) => {
    set(currentUserIdAtom, user.id);
  },
);

export const v2IsAuthenticatedAtom = atomWithStorage<boolean>(
  "pza.v2.isAuthenticated",
  false,
  undefined,
  { getOnInit: true },
);
